module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-type-on-call-24dfec99e0f7a8208e347bd9acec9170.svg";